var map = {
	"./html": 596,
	"./html.js": 596,
	"./json": 602,
	"./json.js": 602,
	"./md": 603,
	"./md.js": 603,
	"./toml": 604,
	"./toml.js": 604,
	"./yaml": 606,
	"./yaml.js": 606
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 595;



//////////////////
// WEBPACK FOOTER
// ../wrappers ^\.\/.*$
// module id = 595
// module chunks = 0